import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { productFruits } from 'product-fruits';
import { CacheService } from 'src/app/cache.service';
import { AppService } from 'src/app/app.service';
import { Token, UserDetails, Notification, NotificationResult } from 'src/app/app.model';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CommonDialogComponent } from 'src/app/common-dialog/common-dialog.component';
import { from, interval, Subject, Subscription } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import {
  filter,
  map,
  mergeMap,
  take,
  takeUntil
} from 'rxjs/operators';
import { filter as _filter, get, toNumber, toLower, isNil, isEmpty, isArray, find, replace } from 'lodash-es';
import { SharedService } from '../../services/shared.service';
import { templateCategoryFeatureFlagMap, templateCategoryRoleMap } from '../../helpers/helpers';
import { NS_Enums, NS_SubscriptionService, customerSupportLink, newPricingRoute, newSubscriptionRoute, oldPricingRoute, oldSubscriptionRoute } from 'src/app/shared/namespaces';
import { ActiveAddonAccess } from 'src/app/account/models/subscription-models';
import { SubscriptionBusinessService } from 'src/app/account/services/subscription-business.service';
import { TrialPlanService, trialPlanEventsKeyEnum } from 'src/app/services/trialplan/trialplan.service';
import { getRolesFromToken } from '../../helpers/jwt.helper';
import { SubscriptionDataService } from 'src/app/account/services/subscription-data.service';
import { NotificationsService } from 'src/app/account/notification-settings-new/services/notifications.service';
import { AlertsService } from 'src/app/modules/alerts/services/alerts.service';
import { AppSwitcherComponent } from '../app-switcher/app-switcher.component';
import { AppSwitcherService } from '../../services/app-switcher/app-switcher.service';
import { ProductFruitService } from 'src/app/services/productFruit/product-fruit.service';
import { SentryService } from 'src/app/services/sentry/sentry.service';
import { PosthogService } from 'src/app/services/posthog/posthog.service';
import { POSTHOG_EVENTS } from 'src/app/services/posthog/posthog.constants';
import { markExplicitLogout } from 'src/app/shared/helpers/explicit-logout.helper';
//declare const Headway: any;
// declare global {
//   interface Window {
//     Intercom: any;
//   }
// }

// window.Intercom = window.Intercom || {};

type TemplatesTabVisibilityReason =
  | 'addon_present'
  | 'addon_absent'
  | 'addon_request_failed'
  | 'missing_subscription'
  | 'nav_click';

interface TemplatesTabAccessResult {
  companySubscriptionId?: number;
  error?: unknown;
  hasAddon: boolean;
  reason: TemplatesTabVisibilityReason;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
  },
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  oldPricingRoute = oldPricingRoute;
  newPricingRoute = newPricingRoute;
  newSubscriptionRoute = newSubscriptionRoute;
  oldSubscriptionRoute = oldSubscriptionRoute;
  customerSupportLink = customerSupportLink;
  routePathEnum = NS_Enums.routePathEnum;
  loggedIn = false;
  userFirstName = '';
  userLastName = '';
  userToken: Token;
  user: UserDetails;
  isOrgAdmin: boolean;
  isOmniAdmin: boolean;
  isAdminSel: boolean = false;
  userId = 0;
  notifications: Notification[] = [];
  noConnection = false;
  hoverText = ''
  notificationTitle = ''
  private since = 0;
  private secondsCounter = interval(10000);
  private freshChatCounter = interval(10000);
  private running = false;
  private subscriptions = new Array<Subscription>();
  clickedOutside = true
  ifBanner = false;
  baseWord: string = this.appService.getBaseWord();
  uncommonBaseWord: string = this.appService.getUncommonBaseWord();
  timeZone = 'GMT';
  userEmail = ''
  thisRoute = ''
  templateRoute: any;
  profileDropdown = false;
  questionDropdown = false;
  ifNotificationDropdown = false;
  ifTrial = false;
  expireDays: number;
  userObject: UserDetails;
  isNotif: boolean = false;
  notifId = []
  notificationCount: any = 0
  updatedDate: number;
  subscriptionPlanId: string;
  hasUserDashboardAccess = false;
  isDatonSetup = false;
  userRole: any = [];
  hasAdminAccess: boolean = false;
  hasCStudioAccess: boolean = false;
  unreadAlertsErrorCount:number;
  userPlan: string;
  unreadCount: number = 0;
  isNewsfeedAttached: boolean = false;

  private paginationInfo: any = {
    totalItems: 0,
    pageSize: 20,
    pageIndex: 0,
  }
  templateFeatureFlags: any;
  templateSarasURL = `/${this.baseWord}/templates/all/saras-templates`
  templateOrgURL = `/${this.baseWord}/templates/all/org-templates`
  templateCategoryRoleMap = templateCategoryRoleMap;
  templateCategoryFeatureFlagMap = templateCategoryFeatureFlagMap;
  showTemplatesTab = false;
  subscriptionDetailsNotLoaded: boolean = false;

  get subscriptionsRoute() {
    return this.showNewBillingDetailsLink ? newSubscriptionRoute : oldSubscriptionRoute;

  }

  get pricingRoute() {
    return this.showNewBillingDetailsLink ? newPricingRoute : oldPricingRoute;
  }

  componentDestroy: Subject<any> = new Subject();
  showNewBillingDetailsLink = false;
  routerEventsSubscription: Subscription;
  constructor(private route: ActivatedRoute, private router: Router, private cacheService: CacheService,
    private appService: AppService, public trialPlanService: TrialPlanService, private dialog: MatDialog, private afAuth: AngularFireAuth,
    private firestore: AngularFirestore, private sharedService: SharedService, private subscriptionBusinessService: SubscriptionBusinessService, private subscriptionDataService: SubscriptionDataService, private notificationService: NotificationsService, private alertsService: AlertsService, private appSwitcherService: AppSwitcherService, private productFruitService: ProductFruitService, private sentryService: SentryService, private posthogService: PosthogService) {
      this.routerEventsSubscription = this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.route),
        map(route => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap(route => route.data)
      ).subscribe(data => {
        this.thisRoute = this.route.snapshot.firstChild?.url[0]?.path || 'integrations-list';
        this.isAdminSel = this.router.url.split('/')[2] === 'admin';
        this.templateRoute = this.route.snapshot.firstChild?.url[1]?.path;
        this.trackPageView(data.title);
        if(get(this.appService, 'subscriptionPlan.planId')) {
          this.trackUser();
        } else {
          this.subscriptionDetailsNotLoaded = true;
        }
      });
  }

  ngOnInit() {
    this.initializeTemplatesTabVisibility();

    if (window.performance && window.performance
      .getEntriesByType('navigation')
      .map((nav: any) => nav.type)
      .includes('reload')) {
      sessionStorage.setItem(NS_Enums.sessionStorageKeysEnum.isTrialSetupStepOneShown, JSON.stringify(false));
    } else {
      // "This page is not reloaded"
    }

    if (this.cacheService.getObject('saras_auth_key')) {
      this.init();
    }
    this.isAdminSel = this.router.url.split('/')[2] == 'admin' ? true : false;
    this.appService.getUserLoginEvent().pipe(takeUntil(this.componentDestroy)).subscribe({
      next: (login) => {
        if (login) {
          this.init();

        } else {

          this.cacheService.clear();
          this.loggedIn = false;
          this.isOrgAdmin = false;
          this.userFirstName = '';
          this.userLastName = '';
          this.router.navigate(['/' + this.uncommonBaseWord + '/login']).then();
        }
      }
    });
    this.appService.getSignInEvent().subscribe({
      next: value => {
        this.signInEvent();
      }
    });

    this.appService.getNoConnectionEvent().subscribe({
      next: value => {
        this.noConnection = value;
      }
    });

    this.appService.getTrialPlanUpdate().subscribe({
      next: value => {
        // this.noConnection = value;
        if (value === '') {
          this.ifTrial = false;
        } else {
          this.ifTrial = true;
          this.expireDays = parseInt(value)

       }

      }
    });

    this.appService.getWarehouseBannerEvent().subscribe({
      next: value => { // console.log(value,"LLLLLLL")
        this.ifBanner = value === true;
      }
    });

    //  this.bootIntercom();

    this.appService.getcurrentUserRole().subscribe({
      next: value => {
        this.isOmniAdmin = value === 'Admin';
        this.isOrgAdmin = this.isOmniAdmin || value === 'OrganizationAdmin';
      }
    });

    let sub = this.appService.getDashboardPermissionGrantedEvent().subscribe({
      next: () => {
        this.getCurrentSubscriptionPlan();
      }
    })

    this.subscriptions.push(sub);

    this.fetchViewedNotifications()
    this.onNewsfeedClick();
  }

  onNewsfeedClick() {
    if (this.isNewsfeedAttached) return;

    const customLauncher = document.getElementById('newsfeed-launcher');
    if (!customLauncher) return;

    productFruits.safeExec(() => {
      if (window.productFruits?.api?.announcementsV2?.attachNewsWidgetToElement) {
        window.productFruits.api.announcementsV2.attachNewsWidgetToElement(customLauncher);
        window.productFruits.api.announcementsV2.listen('newsfeed-unread-count-changed', (data: any) => {
          this.unreadCount = data.count;
        });
        this.isNewsfeedAttached = true;
      }
    });
  }
   ngAfterViewInit() {
  }

  onClick() {
    if (this.clickedOutside) {
      this.questionDropdown = false;
      this.profileDropdown = false;
      this.ifNotificationDropdown = false;
    }
    this.clickedOutside = true
  }

  toggle(type) {
    this.clickedOutside = false
    if (type === 'help&support') {
      this.questionDropdown = !this.questionDropdown;
      this.profileDropdown = false
      this.ifNotificationDropdown = false
    }
    else if (type === 'menu') {
      this.profileDropdown = !this.profileDropdown;
      this.questionDropdown = false;
      this.ifNotificationDropdown = false
    }
    else if (type === 'notifications') {
      this.ifNotificationDropdown = !this.ifNotificationDropdown;
      this.questionDropdown = false
      this.profileDropdown = false
    }
   // this.clickedOutside = true;
  }

  // bootIntercom() {
  //   window.Intercom('boot', {
  //     app_id: 'rvcdjhlk'
  //   });
  // }

  ngOnDestroy() {
    // if (this.subscription) {
    //   this.subscription.unsubscribe();
    // }
    // if (this.subscription2) {
    //   this.subscription2.unsubscribe();
    // }
    this.subscriptionBusinessService.destroy();
    this.trialPlanService.destroy();
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    })

    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }

    this.componentDestroy.next(true);
    this.componentDestroy.complete();
  }

  onEvent(event) {
    event.stopPropagation();
  }

  fetchAndCacheAlertsData(companyId): void {
    // Check if cached data exists
    const cachedData = this.alertsService.getCachedAlertsDataValue();
    if (cachedData) {
      this.unreadAlertsErrorCount = cachedData?.data?.unreadErrorCount;
      return;
    }

    // If no cached data, make the API call
    this.alertsService.getActiveErrorsByCompanyId(companyId).subscribe({
      next: (data: any) => {
        this.unreadAlertsErrorCount = data?.data?.unreadErrorCount;
        this.alertsService.cacheAlertsData(data);
      },
      error: (error) => {
        this.unreadAlertsErrorCount = 0;
        console.error('An error occurred', error);
      }
    });
  }

  getTimeZone(userId: number, runNotifications = false) {
    this.appService.getPreferenceById(userId, 1).then(data => {
      this.timeZone = data.value;
      if (runNotifications) {
       // this.runNotifications();
        this.running = false;
       // this.getNotifications();
        /*test code
        */
      }
    });
  }

 /* openSupportWidget() {
    window['FreshworksWidget']('identify', 'ticketForm',{
      name: `${this.userFirstName} ${this.userLastName}`,
      email: this.userEmail,
    });
  }*/

  private init() {
    this.userToken = this.cacheService.getObject('saras_auth_key');
    this.userId = this.userToken.userId;
    const rolesFromToken = getRolesFromToken(this.userToken.token)
    this.userRole = rolesFromToken || this.userToken.role;
    this.loggedIn = true;
    this.subscriptionBusinessService.initializeProduct('daton');
    this.appService.getUserAsObservable(0).pipe(take(1)).subscribe(async (user) => {
      // window.Intercom('update',
      //   {
      //     user_id: user.userId,
      //     email: user.email
      //   }
      // );
      this.userObject = user;
      this.subscriptionBusinessService.userPlan$
      .pipe(
        filter((plan): plan is string => !!plan),
        take(1)
      )
      .subscribe((plan: string) => {
        this.userPlan = plan;
      });
            
      if (!isNil(user?.company?.companyId) && isEmpty(this.subscriptionBusinessService.companySubscriptions)) {
        this.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(user.company.companyId).pipe(take(1)).subscribe(
          {
            next: (response: any) => {
              if (response) {
                this.subscriptionBusinessService.setCompanySubscriptions(response);
                this.showNewBillingDetailsLink = this.subscriptionBusinessService.checkSubscriptionFeaturePersmission(get(user, 'role'));
              }
            }
          }
        )
      } else {
        this.showNewBillingDetailsLink = this.subscriptionBusinessService.checkSubscriptionFeaturePersmission(get(user, 'role'));
      }
      this.subscriptionBusinessService.eventsSubject.pipe(filter(ev => ev.eventKey == NS_SubscriptionService.eventSubjectDataEventKeyEnum.oldSubscription),
        take(1)
      ).subscribe({
        next: () => {
          this.showNewBillingDetailsLink = this.subscriptionBusinessService.checkSubscriptionFeaturePersmission(this.userObject?.role);
        }
      });

      // window['FreshworksWidget']('identify', 'ticketForm',{
      //   name: `${user.firstName} ${user.lastName}`,
      //   email: user.email,
      // });
      // window['FreshworksWidget']('hide', 'launcher');

      // this.setFreshChatWidget(user, user.restoreid);
      this.userId = user.userId;
      this.getTimeZone(this.userId, true);
      this.isOmniAdmin = (user.role === 'Admin');
      this.isOrgAdmin = this.isOmniAdmin || (user.role === 'OrganizationAdmin');
      this.appService.getcurrentUserRole().next(user.role);
      this.userFirstName = user.firstName;
      this.userLastName = user.lastName;
      this.userEmail = user.email;
      this.hoverText = 'Hello ' + this.userFirstName + ' ' + this.userLastName + '\n' + this.userEmail
      this.cacheService.putObject(NS_Enums.cacheKeysEnum.user_details, user, true);
      this.fetchAndCacheAlertsData(user?.company?.companyId);

      this.appSwitcherService.getLatestEntries(user?.company?.companyId);
      this.productFruitService.initProductFruit(this.userObject);
    }, (error) => {
      console.log('getuser error', error);
    });

    this.getCurrentSubscriptionPlan();

  }

  private trackUser() {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      event: "track_user_id",
      user_id: this.userId,
      user_type: "Guest",
      user_role: this.userRole || null,
      account_plan: get(this.appService, 'subscriptionPlan.planId', null)
    });
  }

  private trackPageView(pageTitle) {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      event: "virtual_pageview",
      page_location: get(window, 'location.href'),
      page_title: pageTitle || null,
    });
  }

  /**
   * Tracks a Templates tab click in PostHog.
   */
  onTemplatesTabClick(): void {
    this.posthogService.captureEvent(
      POSTHOG_EVENTS.TEMPLATES_TAB_CLICKED,
      this.getTemplatesTabEventProperties({
        is_visible: true,
        is_success: true,
        reason: 'nav_click',
        company_subscription_id: get(
          this.subscriptionBusinessService,
          'currentlyActiveCompanySubscription.id'
        )
      })
    );
  }

  private initializeTemplatesTabVisibility(): void {
    const addonName =
      NS_SubscriptionService.companySubscriptionAddonNameEnum
        .DATON_CONNECT_TEMPLATE;
    this.subscriptionBusinessService.hasActiveAddon$(addonName).pipe(
      takeUntil(this.componentDestroy)
    ).subscribe(access => this.applyTemplatesTabAccess(access));
  }

  private applyTemplatesTabAccess(access: ActiveAddonAccess): void {
    const result = this.toTemplatesTabAccessResult(access);
    this.showTemplatesTab = result.hasAddon;
    if (result.error) {
      const exception = result.error instanceof Error
        ? result.error
        : new Error('Unable to load company subscription add-ons');
      this.sentryService.captureException(exception, {
        companySubscriptionId: result.companySubscriptionId
      });
    }
    if (result.reason === 'missing_subscription') {
      return;
    }
    this.trackTemplatesTabVisibility({
      isVisible: result.hasAddon,
      isSuccess: !result.error && !!result.companySubscriptionId,
      reason: result.reason,
      companySubscriptionId: result.companySubscriptionId
    });
  }

  private toTemplatesTabAccessResult(
    access: ActiveAddonAccess
  ): TemplatesTabAccessResult {
    if (access.error) {
      return {
        companySubscriptionId: access.companySubscriptionId,
        error: access.error,
        hasAddon: false,
        reason: 'addon_request_failed'
      };
    }
    if (isNil(access.companySubscriptionId)) {
      return {
        hasAddon: false,
        reason: 'missing_subscription'
      };
    }
    return {
      companySubscriptionId: access.companySubscriptionId,
      hasAddon: access.hasAddon,
      reason: access.hasAddon ? 'addon_present' : 'addon_absent'
    };
  }

  private trackTemplatesTabVisibility(params: {
    isVisible: boolean;
    isSuccess: boolean;
    reason: TemplatesTabVisibilityReason;
    companySubscriptionId?: number;
  }): void {
    this.posthogService.captureEvent(
      POSTHOG_EVENTS.TEMPLATES_TAB_VISIBILITY_UPDATED,
      this.getTemplatesTabEventProperties({
        is_visible: params.isVisible,
        is_success: params.isSuccess,
        reason: params.reason,
        company_subscription_id: params.companySubscriptionId
      })
    );
    if (params.isSuccess) {
      this.posthogService.setUserProperties({
        has_daton_connect_template: params.isVisible
      });
    }
  }

  private getTemplatesTabEventProperties(properties: {
    is_visible: boolean;
    is_success: boolean;
    reason: TemplatesTabVisibilityReason;
    company_subscription_id?: number;
  }) {
    return {
      addon_name:
        NS_SubscriptionService.companySubscriptionAddonNameEnum
          .DATON_CONNECT_TEMPLATE,
      user_id: this.userId || null,
      company_id: get(this.userObject, 'company.companyId', null),
      ...properties
    };
  }


  private async getCurrentSubscriptionPlan() {
    this.appService.getCurrentSubscriptionPlan(this.userId).then(plan => {
      //console.log("XXX")
      // this.cacheService.putObject('advFrequency', plan.body.advFrequency, true);
      // this.cacheService.putObject('advHistory', plan.body.advHistory, true);
      this.appService.subscriptionPlan = plan?.body;
      this.subscriptionBusinessService.setOldSubscriptionFromHeaderComponent(plan?.body);
      this.subscriptionPlanId = get(plan, 'body.planId');
      this.hasUserDashboardAccess = toLower(get(plan, 'body.features.dashboard', 'no')) === "yes";
      this.isDatonSetup = toLower(get(plan, 'body.features.datonSetup', 'no')) === "yes";
      if(this.subscriptionDetailsNotLoaded) {
        this.trackUser();
        this.subscriptionDetailsNotLoaded = false;
      }

      if (plan?.body?.trialEnds === 0 ||
        plan?.body?.trialStarts === 0) { this.ifTrial = false }
      else {
        const now = (new Date()).getTime();
        const trialEnds = plan?.body?.trialEnds;
        const difference = trialEnds - now;
        if (difference > 0) {
          this.expireDays = Math.round(((((difference / 1000) / 60) / 60) / 24))
          this.ifTrial = true;
        }
      }
      this.initTemplateChecks();
    });
  }

  ifTitle(notification, index) {
    if (index === 0) { this.notificationTitle = '' }
    if (this.notificationTitle === '' || !(notification.title === this.notificationTitle)) {
      this.notificationTitle = notification.title;
      return true
    } else {
      this.notificationTitle = notification.title;
      return false
    }


  }

  openWidget() {
    //  FreshworksWidget('open');
    // window['FreshworksWidget']('open', 'ticketForm');
    // const HW_config = {
    //   selector: '.update-bttn',
    //   account: 'x9wR6J'
    // };
   // Headway.init()
  }

  getMoreInformation(): string {
    return 'Address : Home \n  Tel : Number';
    }

  private setFreshChatWidget(user, restoreId) {
    let counter = this.freshChatCounter.subscribe(() => {
      try {
        if (window['fcWidget']) {

          window['fcWidget'].init({
            token: 'ae67e442-214e-46c5-ad01-5786b7866b49',
            host: 'https://wchat.freshchat.com',
            externalId: (user.userId).toString(),
            restoreId: restoreId ? restoreId : null
          });
          // window['fcWidget'].setExternalId((user.userId).toString());
          window['fcWidget'].user.setFirstName(user.firstName);
          window['fcWidget'].user.setEmail(user.email);
          counter.unsubscribe();

          window['fcWidget'].on('user:created', (resp) => {
            const status = resp && resp.status,
              data = resp && resp.data;
            if (status === 200) {
              if (data.restoreId) {
                // Update restoreId in your database
                this.appService.saveRestoreIdFreshChat(user.userId, data.restoreId).then(sta => {

                });
              }
            }
          });

        }
      } catch (error) {

      }

    });

  }


  // private runNotifications() {
  //   return this.appService.fetchAllNotifications(this.since, this.userId).subscribe(next => {
  //     next.forEach(value => {
  //       const i = this.indexOf(value);
  //       if (i >= 0) {
  //         this.notifications.splice(i, 1);
  //       }
  //       if (value.status === 'SHOW') {
  //         const currentStamp = +new Date();
  //         value.minsBack = this.appService.abbreviateNumber(currentStamp - value.createdDate, true, true, value.createdDate, this.timeZone);
  //         value.title = this.appService.notificationTitle(currentStamp - value.createdDate,value.createdDate, this.timeZone)
  //         this.notifications.push(value);
  //       }
  //       if (value.updatedDate > this.since) {
  //         this.since = value.updatedDate;
  //       }
  //     });
  //    // this.appService.getNotifications().next(this.notifications);
  //   });

  // }

  getNotificationType(type) {
    switch (type) {
      case 'ALERT': return 'warning';
      case 'CONFIRM': return 'success';
      case 'INFO': return 'info';
      case 'ERROR': return 'error';
    }
  }

  getIcon(type) {
    switch (type) {
      case 'ALERT': return 'fa-exclamation-circle';
      case 'CONFIRM': return 'fa-check-circle';
      case 'INFO': return 'fa-exclamation-circle';
      case 'ERROR': return 'fa-times-circle';
    }
  }

  // private updateNotifications(ns: Notification[]) {
  //   ns.forEach(value => {
  //     const i = this.indexOf(value);
  //     if (i >= 0) {
  //       this.notifications.splice(i, 1);
  //     }
  //     if (value.status === 'SHOW') {
  //       const currentStamp = +new Date();
  //       value.minsBack = this.appService.abbreviateNumber(currentStamp - value.createdDate, true, true, value.createdDate,
  //         this.timeZone);
  //       this.notifications.unshift(value);
  //     }
  //     if (value.updatedDate > this.since) {
  //       this.since = value.updatedDate;
  //     }
  //   });
  //   this.appService.getNotifications().next(this.notifications);
  // }

  // private getNotifications() {
  //   this.subscription = this.secondsCounter.subscribe(() => {
  //     if (!this.running && this.loggedIn) {
  //       this.running = true;
  //    //   this.subscription2 = this.appService.fetchAllNotifications(this.since, this.userId).subscribe(next => {
  //     let reportral: Array<Notification>;
  //     this.firestore.collection('panel-notifications', ref =>
  //     ref.where('userId', '==', this.userId)
  //       .orderBy('updated', 'desc')
  //       ).valueChanges()
  //       .subscribe((reports: Array<Notification>) => {
  //         this.updateNotifications(reports);
  //       }, () => {
  //         this.running = false;
  //       }, () => {
  //         this.running = false;
  //       });
  //     }
  //   });
  // }

  clearAllNotifications() {
    // this.appService.clearAllNotifications(this.userId).then((data) => {
    //   this.appService.fetchAllNotifications(this.since, this.userId).subscribe(next => {
    //     this.updateNotifications(next);
    // const docum = this.firestore.collection('panel-notifications',
    //   ref => ref.where('userId', '==', 36).where('status', 'in', ['SHOW', 'CREATED']));
    // docum.snapshotChanges().subscribe((res: any) => {
    //  res.forEach(element => {
    //   const id = element.payload.doc.id;
    //    const updateData = {status: 'CLOSED'};
    //    this.firestore.doc(`notifications/${id}`).update(updateData);

    //   });
    // });
    this.notifications.forEach(element => {
      const id = element.notificationId
      this.firestore.doc(`panel-notifications/${id}`).update({ status: 'CLOSED' })
    });
  }

  private indexOf(notification: Notification): number {
    for (let i = 0; i < this.notifications.length; i++) {
      if (notification.notificationId === this.notifications[i].notificationId) {
        return i;
      }
    }
    return -1;
  }

  close(notification: Notification, result: string) {

    const id = notification.notificationId
    this.firestore.doc(`panel-notifications/${id}`).update({ status: 'CLOSED' });
    //   const data: NotificationResult = {result: result};
    // this.appService.closeNotification(notification.notificationId, this.userId, data)
    //   .then(() => {
    //     const i = this.indexOf(notification);
    //     if (i >= 0) {
    //       this.notifications.splice(i, 1);
    //     }
    //     this.appService.getNotifications().next(this.notifications);
    // const docum = this.firestore.collection('panel-notifications',
    // ref => ref.where('userId', '==', this.userId).where('status', 'in', ['SHOW', 'CREATED']));
    // docum.snapshotChanges().subscribe((res: any) => {
    //   res.forEach(element => {console.log(element)
      //  const id = element.payload.doc.id;
      //   this.firestore.doc(`notifications/${id}`).update(data);
      //   this.firestore.doc(`notifications/${id}`).update({status: 'CLOSED'});

    //   });
    // });
    // this.fetchNotifications();

  }


  async fetchNotifications() {
    try {
      const response = await this.appService.getNotifications_vm(this.userId, this.paginationInfo);
      const notifications = get(response, 'content', []);
      const updatedTime = _filter(notifications, notification => {
        console.log(notification.updatedDate > this.appService.viewedNotificationsAt);
        return this.appService.viewedNotificationsAt ? notification.updatedDate > this.appService.viewedNotificationsAt : true;
      });
      this.notificationCount = get(updatedTime, 'length', 0);
    } catch (error) {
      console.log(error);
    }
  }

  fetchViewedNotifications() {
    this.firestore.collection('panel-notifications', ref =>
      ref.where('userId', '==', this.userId).orderBy("updatedDate", "desc").where('status', 'in', ['VIEWED']).limit(1)).
      snapshotChanges().subscribe((viewedNotification: Array<any>) => {
        viewedNotification.forEach(element => {
          this.updatedDate = (element.payload.doc.data().updatedDate)
          this.fetchNotifications()
        })
      })
  }

  viewAllNotifications() {
    localStorage.setItem('viewedNotificationsAt', ((new Date()).getTime()).toString());
    this.appService.viewedNotificationsAt = toNumber(localStorage.getItem('viewedNotificationsAt'));
    this.isNotif = false
    this.notificationCount = 0
    //console.log(this.notificationCount)
  }


  home(event) {
    event.preventDefault();
    this.router.navigate(['/']).then();
  }

  goToNewAdmin() {
    window.open("https://datonadmin.sarasanalytics.com/apps/Admin", "_blank");
  }

  goToDashboard() {
    window.open("https://datonadmin.sarasanalytics.com/apps/Dashboard", "_blank");
  }

  logout() {
    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: 'Logging Off',
        content: 'Do you really want to logout?',
        image: 'warning',
        buttons: [
          {
            'title': 'YES',
            'meta': '/' + this.uncommonBaseWord + '/login',
            'type': 'logout',
            'class': 'confirm-dialog-later'
          },
          {
            'title': 'NO',
            'meta': '',
            'type': 'no-change',
            'class': 'confirm-dialog-proceed'
          }
        ]
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.type === 'logout') {
        this.cacheService.removeSharedCookie();
        markExplicitLogout();

        this.afAuth.signOut().then(() => {
          this.appService.logout(this.userObject).then(() => {
            this.cacheService.clear();
            //  this.bootIntercom();
            this.router.navigate([result.meta]);
            //   window.Intercom('shutdown');
          });
        });
      }
    });
  }

  signIn() {
    this.appService.getSignInEvent().next(null);
  }

  signInEvent() {
    this.appService.routeToLogin();
  }

  appSwitcher(){
    this.appSwitcherService.appSwitcherDialog = this.dialog.open(AppSwitcherComponent, {width:'194px',
      height:'86px',
      hasBackdrop:true,
      disableClose: false,
      panelClass: 'app-switcher',
      position: { top: '64px', right: '192px'}
    })
  }

  async initTemplateChecks() {
    try {
      const response = await this.sharedService.templateServiceInit()
      this.templateFeatureFlags = response;
    } catch (error) {
      console.log(error)
    }
  }
  get userPlanClass(): string {
    if (!this.userPlan) return '';
    return 'user-border-' + replace(toLower(this.userPlan), '_', '-');
  }
}
